"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const H3 = (props) => {
  const _a = props, { className, size = IconSize.Medium, color = "inherit" } = _a, rest = __objRest(_a, ["className", "size", "color"]);
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    __spreadValues({ width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass }, rest),
    /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_2967_12418)" }, /* @__PURE__ */ React.createElement("path", { d: "M12 5H15V19H12V13H7V19H4V5H7V11H12V5Z" }), /* @__PURE__ */ React.createElement("path", { d: "M19.1845 14.8255V12.928H19.729C20.455 12.928 21.016 12.6145 21.016 11.905C21.016 11.344 20.6365 10.915 19.993 10.915C19.2835 10.915 18.8875 11.4265 18.8215 12.037H16.2805C16.495 10.2055 17.848 8.704 20.0755 8.704C22.204 8.704 23.524 9.9745 23.524 11.806C23.524 12.6805 23.0455 13.5385 22.4185 13.885C23.227 14.2645 23.656 15.0895 23.656 16.0135C23.656 17.812 22.2865 19.165 20.059 19.165C17.7325 19.165 16.264 17.7955 16.132 15.7495H18.772C18.838 16.4425 19.2505 16.9375 20.0095 16.9375C20.6695 16.9375 21.1315 16.525 21.1315 15.8815C21.1315 15.1885 20.587 14.8255 19.8115 14.8255H19.1845Z" })),
    /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_2967_12418" }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "white" })))
  );
};
export default H3;
